export enum Difficulties {
  White = '1',
  Green = '2',
  Blue = '3',
  Black = '4',
  DoubleBlack = '5',
}
